(function CpLoader($, Adzuki)
{
	"use strict";

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['CruiseBooking/start', 'CruiseBooking/categories', 'CruiseBooking/cabins'], function onload() {
			$('.cp-loader').click(function cpLoaderClicked() {
				var html = '<img src="' + Adzuki.base_uri + '/adzuki/images/econnect-loader-homer.gif">';

				$modal.find('.modal-title').text('Processing...');
				$modal.find('.modal-body').html(html);

				$modal.modal('show');
			});
		}, true);
	});

}(jQuery, window.Adzuki || {}));
